var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoGitlab = function SvgLogoGitlab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m8 14.896 2.578-7.933H5.422z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 14.896 5.422 6.963H1.81z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m1.81 6.963-.784 2.41c-.071.22.007.461.194.597L8 14.896zM1.81 6.963h3.612L3.87 2.184a.267.267 0 0 0-.508 0zM8 14.896l2.578-7.933h3.613z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m14.19 6.963.784 2.41a.53.53 0 0 1-.194.597L8 14.896zM14.19 6.963h-3.612l1.552-4.779a.267.267 0 0 1 .508 0z",
    clipRule: "evenodd"
  })));
};
export default SvgLogoGitlab;